import { FC } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  InformationBox,
  MuiButtonPrimary,
  MuiGrid,
} from "../../../../components";
import PermissionWrapper from "../../../../components/permissionWrapper/PermissionWrapper";
import { MODULE_PERMISSIONS, PAGE_URLS } from "../../../../helpers/constants";
import { replaceHashWithValue } from "../../../../helpers/utils";
import { useSiteCore } from "../../../../hooks/useSiteCore";
import { createProgramSiteCoreKeys } from "../../../createProgramTemplate/siteCore/SiteCoreKeys";
import { ViewProgramTemplateHeaderWrapper } from "./ViewProgramTemplateHeader.style";

interface ViewProgramTemplateHeaderProps {
  title: string;
}

export const ViewProgramTemplateHeader: FC<ViewProgramTemplateHeaderProps> = ({
  title,
}) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { fetchLabel, commonLabels } = useSiteCore();

  const handleNavigate = () => {
    navigate(`${PAGE_URLS.EDIT_PROGRAM_TEMPLATE}/${id}`);
  };

  const viewProgramTemplateTitle = replaceHashWithValue(
    fetchLabel(
      createProgramSiteCoreKeys.profileSection,
      createProgramSiteCoreKeys.viewProgramTemplate,
    ),
    {
      TemplateName: title ?? "",
    },
  );

  return (
    <ViewProgramTemplateHeaderWrapper>
      <MuiGrid container>
        <MuiGrid
          size={{ sm: 6, xs: 12 }}
          className="header-left"
          data-testid="view-program-template-header"
        >
          <InformationBox title={viewProgramTemplateTitle} />
        </MuiGrid>

        <PermissionWrapper
          permission={MODULE_PERMISSIONS.PROGRAM_TEMPLATE_EDIT}
        >
          <MuiGrid size={{ sm: 6, xs: 12 }} className="header-right">
            <MuiButtonPrimary
              onClick={handleNavigate}
              className="header-right-button"
              id="edit-btn"
            >
              {commonLabels.edit}
            </MuiButtonPrimary>
          </MuiGrid>
        </PermissionWrapper>
      </MuiGrid>
    </ViewProgramTemplateHeaderWrapper>
  );
};
